import Configs from '../../app/MenuConfig';

export default Configs;
